<template>
  <div class="modal" :class="{'active': modalActive}">
    <div class="modal__bg" @click="closeModal"></div>
    <!-- Modal exit game -->
    <modal-exit-game :closeModal="closeModal" v-if="modal.exitGame"></modal-exit-game>
    <modal-crop-image-profile :closeModal="closeModal" v-if="modal.cropImageProfile"></modal-crop-image-profile>
    <modal-finish-game v-if="modal.finishGame"></modal-finish-game>
    <modal-no-access-game v-if="modal.noAccessGame"></modal-no-access-game>
    <modal-update-version-app v-if="modal.updateVersionApp"></modal-update-version-app>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import persistentData from '@/plugins/persistentData'
import ModalExitGame from '@/components/Modal/Modules/ExitGame'
import ModalFinishGame from '@/components/Modal/Modules/FinishGame'
import ModalCropImageProfile from '@/components/Modal/Modules/CropImageProfile'
import ModalNoAccessGame from '@/components/Modal/Modules/NoAccessGame'
import ModalUpdateVersionApp from '@/components/Modal/Modules/UpdateVersionApp'

export default {
  components: {
    ModalExitGame,
    ModalFinishGame,
    ModalCropImageProfile,
    ModalNoAccessGame,
    ModalUpdateVersionApp
  },
  computed: {
    ...mapState({
      modalActive: state => state.ModalModule.modalActive,
      modal: state => state.ModalModule.modal
    })
  },
  methods: {
    closeModal() {
      if (this.modal.updateVersionApp || this.modal.noAccessGame) return;
      // Finish game
      if (this.modal.finishGame) {
        this.$store.dispatch('closeModal')
        const dataGame = persistentData.getData(`game-${this.$route.params.id}`, true)
        
        if ( dataGame ) {
          this.$store.dispatch('gameLeave', {
            gameId: dataGame.gameId,
            teamId: dataGame.teamId
          })
          this.$store.dispatch('destroyGameStat')
          this.$store.dispatch('destroyUserIsInGame')
          persistentData.removeData(`game-${this.$route.params.id}`)
          this.$router.push('/home/games')
        }
      } else {
        this.$store.dispatch('closeModal')
      }
    }
  },
  watch: {
    'modalActive': function() {
      const tagBody = document.getElementsByTagName('body')[0]
      tagBody.style.overflowY = this.modalActive ? "hidden" : "visible";
      // if (this.isMobile) tagBody.style.position = this.modalActive ? "fixed" : "initial";
      tagBody.style.position = this.modalActive ? "fixed" : "initial";
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.modal {
  position: fixed;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 10;
  top: 0;
  display: none;

  &.active {
    display: flex;
  }

  .modal__bg {
    background: $deepblue;
    opacity: .9;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    z-index: -1;
  }

  // .container {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }
}
</style>